module.exports = __webpack_public_path__ + "static/img/HOME1 1024x768.5533dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/home/HOME1 1024x768.jpg
// module id = 5fZQ
// module chunks = 47